module.exports = __webpack_public_path__ + "img/banner_left.99ab7c66.jpg";